module.exports = __webpack_public_path__ + "media/video.69c3cfaf.mp4";